/**
 * @generated SignedSource<<0c496093b7aa15457de04a36f55c2d91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonalizedCollectionsContext_item$data = {
  readonly categoryCode: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PersonalizedCollectionsContext_item";
};
export type PersonalizedCollectionsContext_item$key = {
  readonly " $data"?: PersonalizedCollectionsContext_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonalizedCollectionsContext_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonalizedCollectionsContext_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ab957e173cc7587b325678b47be89db3";

export default node;
